import { IApiOptions, ILineLonRemarkTemplateItem } from 'x/types'
// import CONS from 'x/config/constants'

import api from './api'

// POST api/line_lon_remark_templates/list
// Example response:
// {
//    "line_lon_remark_templates":[
//       {
//          "id":1,
//          "label_text":"ส่งคอนเฟริม์พรีออเดอร์",
//          "label_color":"00FF00",
//          "label_order":1,
//          "remark":"ขอบคุณที่เปิดพรีออเดอร์กับทางร้าน XYZ กดปุ่ม More Detail เพื่อดูรายละเอียดออเดอร์ แจ้งชำระเมื่อสินค้ามา และดูสถานะการจัดส่งได้ค่ะ",
//          "created_by_user_id":2,
//          "created_at":"2025-12-22 13:21:45"
//       },
//       {
//          "id":2,
//          "label_text":"แจ้งเตือนให้ชำระ สินค้ามาแล้ว",
//          "label_color":"00FF00",
//          "label_order":2,
//          "remark":"สินค้าที่สั่งไว้มาแล้วจ้า กดปุ่ม More Detail เพื่อแจ้งชำระได้ ภายใน 3 วัน",
//          "created_by_user_id":2,
//          "created_at":"2025-12-22 13:21:45"
//       }
//    ]
// }

type IGetLineLonRemarkTemplateListRequestBody = {
  store_id: number
}

type IGetLineLonRemarkTemplateListResponse = {
  remark_templates: ILineLonRemarkTemplateItem[]
}

export async function GetLineLonRemarkTemplateList(
  params: IGetLineLonRemarkTemplateListRequestBody
): Promise<ILineLonRemarkTemplateItem[]> {
  const { store_id } = params

  if (!store_id) {
    throw new Error('GetLineLonRemarkTemplateList:: Need store_id')
  }

  const apiOptions: IApiOptions = {
    // messages: {
    //   successMsg: 'แก้ไขการตั้งค่าร้านค้าสำเร็จ',
    //   errorMsg: 'ล้มเหลวในการแก้ไขการตั้งค่า',
    // },
    showSpinner: true,
    isApiV2: true,
    axiosOptions: {
      timeout: 18000,
    },
  }

  // // return mock data for testing
  // return [
  //   {
  //     id: 1,
  //     label_text: 'ส่งคอนเฟริม์พรีออเดอร์',
  //     label_color: '#00FF00',
  //     label_order: 1,
  //     remark:
  //       'ขอบคุณที่เปิดพรีออเดอร์กับทางร้าน XYZ กดปุ่ม More Detail เพื่อดูรายละเอียดออเดอร์ แจ้งชำระเมื่อสินค้ามา และดูสถานะการจัดส่งได้ค่ะ',
  //     created_by_user_id: 2,
  //     created_at: '2025-12-22 13:21:45',
  //   },
  //   {
  //     id: 2,
  //     label_text: 'แจ้งเตือนให้ชำระ สินค้ามาแล้ว',
  //     label_color: '#00FF00',
  //     label_order: 2,
  //     remark: 'สินค้าที่สั่งไว้มาแล้วจ้า กดปุ่ม More Detail เพื่อแจ้งชำระได้ ภายใน 3 วัน',
  //     created_by_user_id: 2,
  //     created_at: '2025-12-22 13:21:45',
  //   },
  // ]

  try {
    console.log('In GetLineLonRemarkTemplateList:: reqBody => ', params)
    const res = await api.post<IGetLineLonRemarkTemplateListRequestBody, IGetLineLonRemarkTemplateListResponse>(
      'line_lon/remark_template/list',
      params,
      apiOptions
    )
    console.log('In GetLineLonRemarkTemplateList:: response => ', res)

    if ('remark_templates' in res) {
      const normalizedTemplates = res.remark_templates
        .map((tmpl) => {
          return {
            ...tmpl,
            label_color: tmpl.label_color.startsWith('#') ? tmpl.label_color : `#${tmpl.label_color}`,
          }
        })
        .sort((a, b) => a.label_sort_order - b.label_sort_order) // sort by label_sort_order ascending

      return normalizedTemplates
    }
  } catch (err) {
    console.log('In fetchPatchStore:: err => ', err)
    throw err
  }

  return []
}
